import React, { useState } from "react";
import { Button, DropdownButton, Dropdown, DropdownItem, DropdownMenu} from "@deere/fuel-react";
import { SELF_SERVICE_STEPS, ADD_NEW_SECTION, PREVIOUS_BTN, NEXT_BTN, PUBLISH_BTN, SAVE_BTN, SELF_SERVICE_STEP_TITLES, DEFAULT_LANGUAGE_CODE, SELF_SERVICE_QUE_TYPES_GENERIC, SELF_SERVICE_QUE_TYPES_PART, LBL_HELP_DOC, NONE_PART_SECTION, PART_SECTION, SELFSERVICE_LANDING_PATH } from "../../../utils/surveyLiterals";
import { useOktaAuth } from "@okta/okta-react";
import { saveSurveySelfService } from "../../../services/survey.service";
import { ModalSubmit } from "../../../components/ModalSubmit";
import { getHelpDocPdfBySurveyId, uploadHelpDoc } from "../../../services/surveyHelpDoc.service";
import { useTranslation } from "react-i18next";
import { ModalDocument } from "../../../components/modals/ModalDocument";
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router';

const SelfServiceButtons = ({ activeStep, setActiveStep, addNewhandler, fnValidate, payloadData, setPayloadData, setShowDraftSuccess, setCurrentLang, currentLang, isViewOnly, isPartTemplate, addNewParthandler }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [currentLanguageCode, setCurrentLanguageCode] = useState( DEFAULT_LANGUAGE_CODE);
  const { authState } = useOktaAuth();
  const location = useLocation();
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showHelpDocModal, setShowHelpDocModal] = useState(false);
  const [docUrl, setDocUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const selfServiceQueTypes =  [...SELF_SERVICE_QUE_TYPES_GENERIC, ...SELF_SERVICE_QUE_TYPES_PART];
  const surveyStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SURVEY_STEP);
  const languageStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.LANGUAGE_STEP);
  const titleTranslationStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SURVEYTRANSLATION_STEP);
  const agreementId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.AGREEMENT_STEP);
  const sectionStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SECTION_STEP);
  const questionStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.QUESTION_STEP);
  const helpDocStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.HELPDOCSTEP);
  const notificationStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.NOTIFICATION_EMAIL);
  const reviewStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.REVIEW_STEP);
  const saveOrPublishStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SAVEORPUBLISH_STEP);

  const previousHandler = () => {
    setActiveStep((prevState) => {
      return prevState - 1;
    });
  };

  const nextClickHandler = () => {
    fnValidate();
    publishHandler();
  }

  const publishHandler = () => {
    setIsLoading(true);
    const payloadRefined = refinePayloadData(payloadData)
    saveSurveySelfService(payloadRefined, authState.accessToken.accessToken)
      .then((survey) => {
        setIsLoading(false);
        if (survey && survey.id) {
          if (payloadData.active) {
            setShowSubmitModal(true); //Publish
          } else {
            updateUIPropertiesForQuestions(survey); //Save as draft
            survey.editSurvey = location?.state?.payloadData?.editSurvey ?? false; // Flag for revision
          }
          const docsToUpload = payloadData.helpDocs.filter((hd) => hd.isNewUpload);
          if (docsToUpload.length > 0) {
            uploadHelpDoc(docsToUpload, survey.code, survey.templateRevision, authState.accessToken.accessToken)           
                 .then((res) => {
                    setPayloadData(survey);
                    setShowDraftSuccess(true);
                    window.scrollTo(0, 0);
                  })
                  .catch((err) => {
                    setIsLoading(false);
                    console.error(err);
                  });
          } else {
            setPayloadData(survey);
            setShowDraftSuccess(true);
            window.scrollTo(0, 0);
          }
        }
        if (activeStep === saveOrPublishStepId.id && (!payloadData.active)) {
          history.push({
            pathname: "/selfServiceLanding",
            state: { previous: history?.location?.pathname },
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err)
      });
  };

  const changeLanguage = languageCd => {
    setCurrentLang(languageCd);
  }

  const handleDefaultLangClick =(languageCd, e) =>{
    e.preventDefault();
    setCurrentLang(languageCd)
  }
  const updateUIPropertiesForQuestions = (survey) => {
    if (!survey?.sections) return survey;
    const qTypeMap = new Map(selfServiceQueTypes.map(type => [type.code, type]));
    survey.sections.forEach(section => {
      section.questions?.forEach(question => {
        const qType = qTypeMap.get(question.type);
        if (qType) {
          question.typeText = qType.type;
          question.needSelections = qType.needSelections;
        }
      });
    });
    return survey;
  };

  const refinePayloadData = (payloadData) => {
    //Removing empty values from the payload
    return {
      ...payloadData,
      translations: payloadData.translations.filter((translation) => translation.text && translation.text !== ""),
      sections: payloadData.sections
        .filter((section) => section.description && section.description !== "")
        .map((section) => ({
          ...section,
          translations: section.translations.filter((translation) => translation.text && translation.text !== ""),
          questions: section.questions
            .filter((question) => question.text && question.text !== "")
            .map((question) => ({
              ...question,
              translations: question.translations.filter((translation) => translation.text && translation.text !== ""),
              selections: question.selections
                .filter((selection) => selection.text !== "")
                .map(({ point, longDescription, ...rest }) => ({ ...rest, translations: rest.translations.filter((translation) => translation.text && translation.text !== "") })),
            })),
        })),
      helpDocs: payloadData.helpDocs ? payloadData.helpDocs.map(({ formData, ...rest }) => rest) : [], // Remove formData from helpDocs
      agreementPosition: payloadData.agreementData.length === 0 ? "" : payloadData.agreementPosition,
    };
  };

  const helpDocFetcher = async () => {
    if (payloadData && payloadData.helpDocs) {
      const index = payloadData.helpDocs.findIndex((hd) => hd.languageCd === currentLang);
      const file = index > -1 && payloadData.helpDocs[index].formData ? payloadData.helpDocs[index].formData.get("file") : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => setDocUrl(e.target.result);
        reader.readAsDataURL(file);
      } else if (payloadData.id) {
        try {
          const helpDocResponse = await getHelpDocPdfBySurveyId(authState.accessToken.accessToken, payloadData.id, currentLang, true);
          if (helpDocResponse.status === 200) {
            const blob = await helpDocResponse.blob();
            const url = window.URL.createObjectURL(blob);
            setDocUrl(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      setShowHelpDocModal(true);
    }
  };

  const NextButton = () => <Button variant="primary" className="ml-2" onClick={nextClickHandler}>{NEXT_BTN}</Button>;
  const PreviousButton = () => <Button variant="secondary" onClick={previousHandler}>{PREVIOUS_BTN}</Button>;
  const SaveButton = ({active}) => <Button variant="primary" className="ml-2" onClick={publishHandler} disabled={isLoading}>{active ? PUBLISH_BTN : SAVE_BTN}</Button>;
  const AddSectionButton = () => isPartTemplate?
    <Dropdown>
      <DropdownButton variant="primary" style={{ width: "20%", margin: "0px auto 0px 0px" }}>{ADD_NEW_SECTION}</DropdownButton>
      <DropdownMenu>
        <DropdownItem onClick={addNewhandler}>{NONE_PART_SECTION}</DropdownItem>
        <DropdownItem onClick={addNewParthandler}>{PART_SECTION}</DropdownItem>
      </DropdownMenu>
    </Dropdown> 
    :
    <Button variant="primary" onClick={addNewhandler} style={{ width: "20%", margin: "0px auto 0px 0px" }}>{ADD_NEW_SECTION}</Button>;
  const HelpDocButton = () => payloadData.helpDocs.length > 0 && <Button variant="primary" onClick={helpDocFetcher} style={{ margin: "0px auto 0px 0px" }}>{LBL_HELP_DOC}</Button>;
  const LanguageMenu = () =>
    payloadData.language.length > 1 && (
      <Dropdown size="small">
        <DropdownButton onClick={(e) => e.preventDefault()} sx={{ marginRight: "10px" }}>
          {t("btn_change_language")}{" "}
        </DropdownButton>
        <DropdownMenu placement="top-start">
          {payloadData.language.map(({ languageCd, text }) =>
            currentLanguageCode === languageCd ? (
              <DropdownItem key={languageCd} href="#" className="nav-link active" onClick={(e) => handleDefaultLangClick(languageCd, e)}>
                <span className={`flag-icon  mx-2`} style={{ opacity: 0.3 }}></span>
                {text}
              </DropdownItem>
            ) : (
              <DropdownItem key={languageCd} href="#" onClick={() => changeLanguage(languageCd)}>
                <span className={`flag-icon  mx-2`} style={{ opacity: 1 }}></span>
                {text}
              </DropdownItem>
            )
          )}
        </DropdownMenu>
      </Dropdown>
    );

  const renderButtonsForSteps = () => {
    if (isViewOnly) {
      return <><HelpDocButton/><LanguageMenu /></>;
    }
    else {
      switch (activeStep) {
        case surveyStepId.id:
          return <NextButton />;
        case languageStepId.id:
        case titleTranslationStepId.id:
        case agreementId.id:
        case questionStepId.id:
        case helpDocStepId.id:
        case notificationStepId.id:
          return <><PreviousButton /><SaveButton /><NextButton /></>;
        case sectionStepId.id:
          return <><AddSectionButton /><PreviousButton /><SaveButton /><NextButton /></>;
        case reviewStepId.id:
          return <><HelpDocButton/><LanguageMenu /><PreviousButton /><NextButton /></>;
        case saveOrPublishStepId.id:
          return <><PreviousButton /><SaveButton active={payloadData && payloadData.active} /></>;
      }
    } 
  };

  return (
    <>
      {renderButtonsForSteps()}
      <ModalSubmit showModal={showSubmitModal} setShowModal={setShowSubmitModal} titleKey={"lbl_success"} messageKey={"lbl_survey_published"} buttonKey={"btn_OK"} navigateTo={SELFSERVICE_LANDING_PATH} />
      <ModalDocument showModal={showHelpDocModal} setShowModal={setShowHelpDocModal} labelBtnPrimary={t("btn_close")} titleModal={t("lbl_Help_Doc")} iFrameUrl={docUrl} />
    </>
  );
};

export default SelfServiceButtons;
